{
  "bulkOnboarding": {
    "departments": {
      "title": "Créer des départements",
      "description": "Importez un fichier Excel avec la structure des départements de votre organisation. Les départements seront stockés temporairement jusqu'à ce que les responsables soient assignés dans les prochaines étapes.",
      "uploadTitle": "Importer des départements depuis Excel",
      "toast": {
        "createSuccess": "Départements créés avec succès !",
        "createFailed": "Échec de la création des départements",
        "validationRequired": "Veuillez d'abord importer des départements",
        "fixErrors": "Veuillez corriger les erreurs de validation avant de soumettre"
      }
    },
    "users": {
      "title": "Créer des collaborateurs",
      "description": "Importez un fichier Excel avec les collaborateurs de votre organisation. Lors de la création des collaborateurs, les départements avec des e-mails de responsable correspondants seront automatiquement assignés. Les départements restants nécessiteront une résolution manuelle à l'étape suivante.",
      "uploadTitle": "Importer des collaborateurs depuis Excel",
      "toast": {
        "createSuccess": "Collaborateurs créés avec succès ! Les départements avec des e-mails de responsable correspondants ont été automatiquement assignés.",
        "createFailed": "Échec de la création des collaborateurs",
        "validationRequired": "Veuillez d'abord importer des collaborateurs",
        "fixErrors": "Veuillez corriger les erreurs de validation avant de soumettre"
      }
    },
    "processes": {
      "uploadTitle": "Importer des processus depuis Excel",
      "toast": {
        "createSuccess": "Processus créés avec succès ! Les propriétaires de processus ont été automatiquement assignés en fonction des responsables de département.",
        "createFailed": "Échec de la création des processus",
        "fixErrors": "Veuillez corriger les erreurs de validation avant de soumettre"
      }
    },
    "resolution": {
      "description": "Dans certains cas, nous ne pouvons pas associer sans ambiguïté l'e-mail du manager à un collaborateur. Vérifiez vos résultats.",
      "loading": "Chargement des départements temporaires...",
      "instructions": "Sélectionnez un responsable pour chaque département afin de le migrer du statut temporaire au statut permanent.",
      "table": {
        "name": "Nom",
        "abbreviation": "Abréviation",
        "managerEmail": "E-mail recherché",
        "managerFound": "Responsable trouvé et prêt à être résolu",
        "alreadyResolved": "Déjà résolu",
        "noDescription": "Pas de description",
        "assignManager": "Manager assigné"
      },
      "toast": {
        "batchSuccess": "{{count}} département(s) résolu(s) avec succès",
        "partialSuccess": "{{success}} département(s) résolu(s). {{failed}} échoué(s).",
        "batchFailed": "Échec de la résolution des départements",
        "unresolvedDepartments": "Veuillez résoudre tous les départements avant de terminer la configuration. Chaque département doit avoir un responsable assigné."
      },
      "success": {
        "title": "Tous les départements sont résolus !",
        "description": "Tous les départements ont été assignés avec succès à des responsables."
      }
    },
    "assignManager": {
      "selectPlaceholder": "Choisir un collaborateur…"
    },
    "validation": {
      "nameRequired": "Le nom est requis",
      "abbreviationRequired": "L'abréviation est requise",
      "descriptionRequired": "La description est requise",
      "invalidEmail": "Adresse e-mail invalide",
      "firstNameRequired": "Le prénom est requis",
      "lastNameRequired": "Le nom est requis",
      "departmentRequired": "Le département est requis",
      "roleRequired": "Le poste est requis",
      "ownerEmailInvalid": "Une adresse e-mail valide est requise",
      "orgFunctionNameRequired": "La fonction / l'équipe est requise",
      "licenceSeatsInvalid": "Le nombre de licences doit être un nombre entier supérieur ou égal à 0",
      "unknownMemberEmail": "{{email}} ne correspond à aucun membre",
      "duplicateEntry": "Entrée en double",
      "circularParent": "Un département ne peut pas être son propre parent – même via des niveaux intermédiaires",
      "existingMember": "Déjà existant – ce membre fait déjà partie de votre organisation et ne peut pas être modifié ici",
      "roleDescriptionConflict": "Même poste, descriptions différentes – un poste n'a qu'une seule description",
      "accountableEmailInvalid": "adresse e-mail invalide",
      "accountableEmailNotFound": "l'adresse e-mail {{email}} ne correspond à aucun membre"
    },
    "excel": {
      "sheets": {
        "instructions": "Instructions",
        "departments": "Départements",
        "users": "Collaborateurs",
        "processes": "Processus",
        "functions": "Fonctions",
        "teams": "Équipes",
        "memberships": "Membres",
        "systems": "Systèmes",
        "dataSyncPeople": "Collaborateurs"
      },
      "columns": {
        "departments": {
          "name": "Nom*",
          "abbreviation": "Abréviation*",
          "description": "Description",
          "parentAbbreviation": "Abréviation du parent",
          "managerEmail": "E-mail du responsable"
        },
        "users": {
          "firstName": "Prénom*",
          "lastName": "Nom*",
          "email": "E-mail*",
          "department": "Département*",
          "role": "Poste*",
          "roleDescription": "Description du poste"
        },
        "processes": {
          "name": "Nom*",
          "description": "Description*",
          "department": "Département*",
          "ownerEmail": "E-mail du responsable du processus*",
          "accountableEmail": "E-mail du responsable (facultatif)"
        },
        "functions": {
          "name": "Nom*",
          "description": "Description",
          "department": "Département",
          "leadEmail": "E-mail du responsable",
          "email": "E-mail de la boîte partagée"
        },
        "teams": {
          "name": "Nom*",
          "description": "Description",
          "department": "Département",
          "leadEmail": "E-mail du responsable",
          "email": "E-mail de la boîte partagée"
        },
        "memberships": {
          "orgFunctionName": "Fonction / Équipe*",
          "memberEmail": "E-mail du membre*"
        },
        "systems": {
          "name": "Nom*",
          "description": "Description",
          "category": "Catégorie",
          "url": "URL",
          "licenceSeats": "Nombre de licences",
          "ownerEmail": "E-mail du responsable du système*"
        },
        "dataSync": {
          "id": "ID",
          "parentDepartment": "Département parent",
          "lead": "E-mail du responsable",
          "owner": "E-mail du responsable du système",
          "location": "Site"
        }
      }
    }
  },
  "welcomePage": {
    "welcome": "Bienvenue",
    "checkTask": "Vérifiez vos tâches",
    "minimizeVolume": "Effort minimal pour vous, bénéfice maximal pour tous",
    "minimizeVolumeDesc": "Enregistrez et optimisez les processus avec un effort minimal et une efficacité maximale.",
    "allResourceInOne": "Toutes les ressources de processus en un seul endroit",
    "allResourceInOneDesc": "Gérez toutes les ressources liées aux processus de manière centralisée et efficace.",
    "completeProcess": "Vue d'ensemble complète des processus - Facile à comprendre",
    "completeProcessDesc": "Gardez le contrôle de tous les processus grâce à notre représentation BPMN intuitive.",
    "howRecordingWork": "Comment fonctionne l'enregistrement viral de processus ?",
    "continueToDashboard": "Continuer vers le tableau de bord"
  },
  "initialSetup": {
    "title": "Configuration initiale",
    "wizardHeading": "Assistant de configuration BLIKS IO",
    "topBar": {
      "logoAlt": "Logo BLIKS IO"
    },
    "pending": {
      "title": "Configuration initiale pas encore terminée",
      "description": "Votre organisation n'a pas encore été entièrement configurée. Un responsable d'organisation doit d'abord terminer la configuration initiale – dès que ce sera fait, vous pourrez commencer immédiatement. Cette page s'actualise automatiquement."
    },
    "removalBlocked": {
      "department": {
        "processes": "Le département ne peut pas être supprimé : {{count}} processus y font référence. Réattribuez d'abord les processus à un autre département à l'étape Processus."
      },
      "user": {
        "systems": "Le collaborateur ne peut pas être supprimé : {{count}} systèmes l'ont comme responsable. Réattribuez d'abord les systèmes à une autre personne à l'étape Systèmes.",
        "processes": "Le collaborateur ne peut pas être supprimé : {{count}} processus l'ont comme responsable ou créateur. Réattribuez d'abord les processus à une autre personne à l'étape Processus."
      },
      "orgFunction": {
        "mainRole": "La fonction ne peut pas être supprimée : elle est la fonction principale de {{count}} collaborateurs. Modifiez d'abord leur poste à l'étape Collaborateurs."
      }
    },
    "completeBlocked": {
      "title": "La configuration initiale ne peut pas encore être finalisée :",
      "unresolvedDepartments": "{{count}} départements n'ont pas de manager attribué.",
      "goToResolve": "Attribuer les managers",
      "usersWithoutDepartment": "{{count}} collaborateurs n'ont pas de département.",
      "goToUsers": "Aller à l'étape Collaborateurs"
    },
    "steps": {
      "welcome": "Bienvenue",
      "departments": "Départements",
      "employees": "Collaborateurs",
      "resolveManagers": "Résoudre les managers",
      "functions": "Fonctions",
      "teams": "Équipes",
      "systems": "Systèmes",
      "processes": "Processus",
      "overview": "Aperçu & finalisation"
    },
    "stepDescriptions": {
      "departments": "L'ossature de votre organisation",
      "employees": "Des personnes, chacune rattachée à un poste",
      "resolveManagers": "Les managers sont reliés à partir des collaborateurs ajoutés",
      "functions": "Fonctions supplémentaires des collaborateurs",
      "teams": "Équipes dans lesquelles les collaborateurs travaillent ensemble",
      "systems": "Les systèmes logiciels utilisés",
      "processes": "Liste pour la saisie virale ultérieure",
      "overview": "Aperçu de l'organigramme & confirmation"
    },
    "footer": {
      "next": "Suivant",
      "skip": "Passer",
      "finish": "Terminer",
      "start": "C'est parti"
    },
    "autosave": {
      "pending": "Modifications non enregistrées",
      "saving": "Enregistrement…",
      "saved": "Enregistré automatiquement",
      "error": "Échec de l'enregistrement automatique — « Suivant » réessaiera"
    },
    "welcome": {
      "title": "Bienvenue dans BLIKS IO",
      "intro": "Avant que BLIKS IO ne soit déployé dans votre organisation, nous construisons ensemble en quelques étapes une image complète de votre organisation. Pas d'inquiétude : personne ne reçoit de notification pendant la configuration — pas même les personnes que vous créez ici.",
      "checklist": {
        "title": "Ce que vous devriez préparer",
        "departments": "Les départements de votre organisation et leur hiérarchie",
        "people": "Toutes les personnes de votre organisation",
        "systems": "Les systèmes utilisés",
        "processes": "Les processus que vous souhaitez saisir plus tard"
      },
      "pauseResume": "Ces informations se trouvent généralement de manière centralisée dans vos logiciels HCM et EAM. Il manque quelque chose ? Pas de problème — vous pouvez interrompre à tout moment et reprendre exactement là où vous vous étiez arrêté."
    },
    "outcomes": {
      "title": "Voici ce que vous obtiendrez à la fin",
      "description": "Après la configuration initiale, BLIKS IO est prêt à être déployé dans toute votre organisation. Les quatre éléments de base produisent trois résultats clairs.",
      "cards": {
        "structure": {
          "title": "Structure organisationnelle",
          "body": "Départements, postes et équipes & fonctions supplémentaires. L'organigramme se construit automatiquement à partir des relations."
        },
        "systems": {
          "title": "Vue d'ensemble des systèmes",
          "body": "Tous les systèmes utilisés dans votre organisation — y compris les métadonnées du catalogue."
        },
        "processes": {
          "title": "Vue d'ensemble des processus",
          "body": "Les processus que vous souhaitez saisir — la façon dont ils se déroulent réellement sera enregistrée plus tard par BLIKS IO via la saisie virale."
        }
      },
      "hint": "<bold>Deux choses avant de commencer :</bold> Ce n'est pas grave si tout n'est pas encore complet dans l'assistant de configuration — vous pourrez toujours affiner manuellement plus tard. Et souhaitez-vous construire et maintenir votre organisation automatiquement ? Contactez-nous : nous connectons BLIKS IO directement à vos logiciels HCM et EAM."
    },
    "doneNotice": {
      "departments": {
        "title": "Les départements sont déjà configurés",
        "description": "L'import est terminé. <bold>Suivant</bold> enregistre directement les modifications des lignes existantes et les nouvelles lignes. Supprimer une ligne efface l'entrée importée et vide les références qui y pointent – les lacunes ainsi créées doivent être corrigées avant la finalisation. Vous pouvez également modifier ici le responsable d'un département via la colonne E-mail du responsable."
      },
      "users": {
        "title": "Les collaborateurs sont déjà configurés",
        "description": "L'import est terminé. <bold>Suivant</bold> enregistre directement les modifications des lignes existantes et les nouvelles lignes. Supprimer une ligne efface l'entrée importée et vide les références qui y pointent – les lacunes ainsi créées doivent être corrigées avant la finalisation."
      },
      "optional": {
        "title": "Cette étape a déjà été effectuée",
        "description": "Vous pouvez ajouter d'autres entrées à tout moment – les entrées existantes restent inchangées."
      }
    },
    "resolve": {
      "counters": {
        "open": "Ouvert",
        "resolved": "Déjà résolu"
      },
      "suggestion": "Suggestion : {{name}}",
      "applySuggestion": "Appliquer"
    },
    "functionsTeams": {
      "autoCreatedBanner": "{{count}} fonctions ont déjà été créées à partir des intitulés de poste de vos collaborateurs.",
      "functionsSection": {
        "title": "Fonctions",
        "stepTitle": "Créer des fonctions",
        "description": "Souvent, les collaborateurs n'agissent pas en tant que personne mais dans leur fonction — p. ex. « Délégué à la protection des données » ou « Product owner ». Créez-les ici ou importez-les depuis Excel.",
        "hint": "Si vous n'avez pas les données sous la main, vous pouvez passer cette étape — les fonctions peuvent être ajoutées à tout moment."
      },
      "teamsSection": {
        "title": "Équipes",
        "stepTitle": "Créer des équipes",
        "description": "Groupes qui travaillent ensemble — p. ex. « Équipe support de premier niveau ». Créez des équipes puis assignez-leur des membres.",
        "hint": "Optionnel — les équipes peuvent être ajoutées à tout moment, même pendant la saisie des processus."
      },
      "columns": {
        "lead": "Direction",
        "sharedMailbox": "Boîte partagée",
        "member": "Collaborateur",
        "function": "Fonction",
        "team": "Équipe"
      },
      "membershipsTable": {
        "heading": "Membres"
      },
      "mailImportNote": "Lors de l'import Excel, la direction est associée via l'adresse e-mail d'une personne. Les e-mails introuvables sont marqués en rouge et doivent être assignés manuellement à une personne. Vous créerez les équipes à l'étape suivante.",
      "toast": {
        "fixErrors": "Veuillez d'abord corriger les erreurs des lignes importées",
        "createSuccess": "{{created}} entrées créées, {{linked}} appartenances liées",
        "createFailed": "L'import a échoué"
      },
      "mainRoleLockedRemove": "Cette fonction est attribuée comme poste et ne peut donc pas être supprimée – modifiez d'abord le poste des personnes concernées."
    },
    "systems": {
      "title": "Saisir les systèmes",
      "description": "Quels logiciels votre organisation utilise-t-elle ? Saisissez chaque système avec les informations essentielles — ou importez une liste de systèmes existante depuis Excel.",
      "toast": {
        "fixErrors": "Veuillez d'abord corriger les erreurs des lignes importées",
        "createSuccess": "Systèmes enregistrés",
        "createFailed": "Les systèmes n'ont pas pu être créés"
      }
    },
    "processes": {
      "title": "Saisir les processus",
      "description": "Quels processus BLIKS IO doit-il enregistrer ? Ne saisissez ici que la liste principale — les collaborateurs fourniront les détails plus tard.",
      "hint": "Vous pouvez ajouter d'autres processus à tout moment — ou passer entièrement cette étape.",
      "mailImportNote": "Les responsables sont assignés via une personne. Lors de l'import Excel, l'association se fait par e-mail — les e-mails introuvables sont marqués en rouge comme « Utilisateur introuvable ».",
      "ownerEmail": "Responsable du processus (e-mail)"
    },
    "columns": {
      "systems": {
        "name": "Nom du système",
        "licenceSeats": "Licences",
        "owner": "Responsable"
      },
      "processes": {
        "owner": "Responsable du processus",
        "accountable": "Responsable"
      }
    },
    "columnHints": {
      "departments": {
        "name": "Nom complet du département",
        "abbreviation": "Court et unique, p. ex. \"FC\"",
        "description": "De quoi le département est-il responsable ?",
        "parentAbbr": "Vide = niveau supérieur",
        "managerEmail": "E-mail de la personne responsable"
      },
      "users": {
        "firstName": "p. ex. \"Patrick\"",
        "lastName": "p. ex. \"Lenz\"",
        "email": "Professionnel, doit être unique",
        "department": "Département dans lequel la personne travaille",
        "role": "Le poste, p. ex. \"Head of Controlling\"",
        "roleDescription": "Tâches et priorités du poste"
      },
      "functions": {
        "name": "p. ex. \"Délégué à la protection des données\"",
        "description": "Tâches et responsabilités",
        "department": "Vide si transversal",
        "lead": "E-mail de la direction",
        "sharedMailbox": "Boîte partagée, p. ex. support@…"
      },
      "memberships": {
        "member": "Personne qui exerce la fonction",
        "target": "Fonction ou équipe de la personne"
      },
      "systems": {
        "name": "Nom du système ou du fournisseur",
        "category": "p. ex. CRM, ERP, outil RH",
        "url": "Site web du fournisseur",
        "licenceSeats": "Licences disponibles, si limitées",
        "owner": "Personne responsable du système"
      },
      "processes": {
        "name": "p. ex. \"Création de nouveaux clients\"",
        "description": "Que produit le processus ? Début et fin",
        "department": "Département auquel le processus appartient",
        "owner": "Responsable de la mise à jour de la documentation",
        "accountable": "Facultatif — par défaut le responsable du département"
      }
    },
    "fieldExplainer": {
      "required": "Obligatoire",
      "optional": "Optionnel",
      "headings": {
        "departments": "Voici les informations dont nous avons besoin par département",
        "users": "Voici les informations dont nous avons besoin par personne",
        "functionsTeams": "Voici les informations dont nous avons besoin – réparties en deux sections",
        "systems": "Voici les informations dont nous avons besoin par système",
        "processes": "Voici les informations dont nous avons besoin par processus"
      },
      "sections": {
        "entity": "1. Fonction ou équipe",
        "memberships": "2. Appartenances"
      },
      "fields": {
        "departments": {
          "name": "Nom complet du département, p. ex. « Controlling & Reporting »",
          "abbreviation": "Sigle court et unique, p. ex. « FC ». Sert d’ancre pour relier les départements entre eux.",
          "description": "De quoi le département est-il responsable ? p. ex. « Planification, budgétisation, reporting ». La précision de la description peut influencer les résultats des analyses basées sur l’IA. Vous pouvez compléter la description à tout moment par la suite.",
          "parentAbbr": "Le sigle du département parent – à laisser vide uniquement pour le niveau supérieur. Votre organigramme est construit automatiquement à partir de ces relations.",
          "managerEmail": "E-mail de la personne qui dirige le département. Associé automatiquement à l’étape 2 dès que la personne existe en tant que collaborateur."
        },
        "users": {
          "firstName": "Prénom de la personne, p. ex. « Patrick »",
          "lastName": "Nom de la personne, p. ex. « Lenz »",
          "email": "Adresse e-mail professionnelle de la personne. Doit être unique. Comparée aux e-mails des responsables de l’étape 1 et associée automatiquement.",
          "department": "Le sigle du département dans lequel la personne travaille – issu de la liste de l’étape 1. Situe la personne et le poste dans l’organigramme.",
          "role": "Pour quoi la personne est-elle embauchée ? p. ex. « Head of Controlling », « Gestionnaire comptabilité ». Il s’agit du poste.",
          "roleDescription": "De quoi ce poste est-il responsable ? Tâches, responsabilités, priorités. La base des analyses ultérieures – plus la description est précise, meilleurs sont les résultats."
        },
        "functions": {
          "name": "Nom unique de la fonction, p. ex. « Déléguée à la protection des données », ou de l’équipe, p. ex. « First Level Support Team »",
          "description": "Tâches et responsabilités. La base des analyses ultérieures.",
          "department": "Laissez vide pour les fonctions transversales comme « Product Owner ». Ne renseignez ce champ que si les fonctions ou équipes sont clairement rattachées à un département.",
          "lead": "E-mail de la personne qui dirige la fonction ou l’équipe. Souvent, seules les équipes (p. ex. « First Level Support Team ») ont une direction.",
          "sharedMailbox": "Boîte aux lettres partagée de la fonction ou de l’équipe, p. ex. « support@… »"
        },
        "memberships": {
          "member": "E-mail d’une personne de l’étape 2. Une personne peut être active dans autant de fonctions et d’équipes que nécessaire.",
          "target": "Nom de la fonction ou de l’équipe de la section ci-dessus. Relie les personnes aux fonctions."
        },
        "systems": {
          "name": "Comment s’appelle le système ou son fournisseur ? Si le système est connu sous un nom particulier dans votre organisation, utilisez volontiers votre vocabulaire interne.",
          "description": "Décrivez les capacités du système. À quoi l’utilisez-vous dans votre organisation ?",
          "category": "De quel type de système s’agit-il ? p. ex. « CRM », « ERP », « outil RH »",
          "url": "À quelle URL le fournisseur du système est-il joignable ?",
          "licenceSeats": "Pour certains de vos systèmes, vous ne disposez que d’un nombre limité de licences. Si une limite existe, vous pouvez indiquer ce nombre ici. Nous analysons dans quelle mesure votre activité quotidienne utilise les licences disponibles.",
          "owner": "E-mail de la personne responsable du système dans votre entreprise, la mieux placée pour décrire ce qui se passe dans le système et de quelle manière."
        },
        "processes": {
          "name": "Désignation claire, p. ex. « Création de nouveaux clients », « Processus de vente », etc.",
          "description": "Que produit ce processus ? Par quoi commence-t-il, par quoi se termine-t-il ? Cette description est la base des analyses ultérieures et de la saisie par les collaborateurs – plus elle est précise, mieux c’est.",
          "department": "Sigle du département de l’étape 1 auquel le processus appartient.",
          "owner": "E-mail de la personne responsable de ce processus dans BLIKS IO. Important : il s’agit uniquement de la responsabilité de documenter le processus dans BLIKS IO et de le tenir à jour – pas du rôle responsable de son contenu ou de ses résultats dans l’entreprise. Si ce rôle n’est pas clairement défini chez vous, choisissez la personne la mieux placée pour entretenir la documentation.",
          "accountable": "E-mail de la personne responsable de ce processus (au sens RACI). Facultatif : si le champ reste vide, le responsable actuel du département est affiché comme responsable — les changements ultérieurs de direction sont alors repris automatiquement."
        }
      }
    },
    "overview": {
      "title": "Félicitations",
      "subtitle": "Votre organisation est maintenant saisie dans BLIKS IO.",
      "description": "Vous avez mis en place le squelette. Le reste — qui fait réellement quoi, comment les processus se déroulent réellement, quels systèmes fantômes sont utilisés — est désormais ajouté automatiquement par les collaborateurs lors de la saisie.",
      "cards": {
        "departments": "Départements",
        "members": "Collaborateurs & postes",
        "functions": "Fonctions",
        "teams": "Équipes",
        "systems": "Systèmes",
        "processes": "Processus",
        "departmentLevels": "sur {{count}} niveaux",
        "distinctPositions": "{{count}} intitulés de poste",
        "fromPositions": "dont {{count}} issus des postes",
        "readyForRecording": "prêts pour la saisie"
      },
      "organigram": {
        "title": "Votre organigramme",
        "description": "Construit automatiquement à partir des relations entre départements.",
        "fullscreen": "Afficher en plein écran"
      },
      "toast": {
        "completed": "Configuration initiale terminée !",
        "completeFailed": "La finalisation a échoué",
        "pendingChanges": "Certaines modifications n'ont pas encore été appliquées. Veuillez confirmer l'étape concernée avec « Suivant » avant de terminer la configuration."
      },
      "invite": {
        "checkboxLabel": "Envoyer maintenant une invitation à tous les {{count}} membres",
        "helper": "Les membres reçoivent un e-mail pour activer leur compte et définir un mot de passe.",
        "success": "{{count}} invitations envoyées",
        "skipped": "{{count}} membres ignorés"
      }
    },
    "upload": {
      "errorBanner": "Veuillez corriger les erreurs signalées dans le tableau.",
      "invalidRowsCount": "{{count}} ligne(s) avec des erreurs de validation"
    },
    "uploadFromExcel": "Importer Excel",
    "personio": {
      "load": "Charger depuis Personio",
      "loaded": "Chargé depuis Personio.",
      "unlinkDescription": "Les identifiants sont supprimés ; les lignes déjà chargées sont conservées."
    },
    "tables": {
      "departments": "Départements",
      "users": "Collaborateurs",
      "systems": "Systèmes",
      "processes": "Processus"
    },
    "draftTable": {
      "removeRow": "Supprimer la ligne",
      "noSelection": "– aucune sélection –",
      "userNotFound": "Utilisateur introuvable"
    },
    "existingEntities": {
      "title": "Déjà existants ({{count}})",
      "editableNote": "Ces membres existent déjà — le nom et l'e-mail sont verrouillés. Attribuez-leur ici un département et un poste."
    },
    "protectedRows": {
      "lockedIdentity": "Le nom et l'e-mail de ce membre sont gérés par son compte existant et ne peuvent pas être modifiés ici.",
      "placementFailed": "L'enregistrement de l'affectation au département pour les membres existants a échoué."
    },
    "addRow": {
      "department": "Ajouter un département",
      "employee": "Ajouter un collaborateur",
      "orgFunction": "Ajouter une fonction",
      "team": "Ajouter une équipe",
      "membership": "Ajouter un membre",
      "system": "Ajouter un système",
      "process": "Ajouter un processus"
    },
    "clearDrafts": "Vider la liste",
    "clearConfirm": {
      "title": "Vider la liste ?",
      "description": "Toutes les lignes du tableau seront supprimées. Cette action est irréversible.",
      "deleteAllDescription": "Toutes les lignes seront supprimées. Les entrées déjà importées seront définitivement supprimées lorsque vous poursuivrez.",
      "confirm": "Vider"
    },
    "pendingDeleteAll": "La liste a été vidée : toutes les entrées importées seront définitivement supprimées lorsque vous poursuivrez avec « Suivant ».",
    "doneBadge": "Terminé",
    "usersImport": {
      "membersNotLoaded": "La liste des membres n'a pas encore été chargée – veuillez réessayer."
    }
  }
}
